import { $authHost } from "../../http";
import { 
    REAGENT_GET_REQUEST, REAGENT_GET_SUCCESS, REAGENT_GET_ERROR, 
    REAGENT_GET_BY_KEY_REQUEST, REAGENT_GET_BY_KEY_SUCCESS, REAGENT_GET_BY_KEY_ERROR, 
    REAGENT_ADD_REQUEST, REAGENT_ADD_SUCCESS, REAGENT_ADD_ERROR, 
    REAGENT_EDIT_REQUEST, REAGENT_EDIT_SUCCESS, REAGENT_EDIT_ERROR, 
    REAGENT_DELETE_REQUEST, REAGENT_DELETE_SUCCESS, REAGENT_DELETE_ERROR
} from "../constants/reagentConstants";

export const getReagents = (args) => async (dispatch) => {
    try {
        dispatch({
            type: REAGENT_GET_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        const {data} = await $authHost.post(
            "/api/v1/reagent/query",
            args || {},
            config,
        );
        dispatch({
            type: REAGENT_GET_SUCCESS,
            payload: data.result,
        });
        return data.result;
    } catch (error) {
        dispatch({
            type: REAGENT_GET_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const getReagentByKey = (id) => async (dispatch) => {
    try {
        dispatch({
            type: REAGENT_GET_BY_KEY_REQUEST
        });

        const {data} = await $authHost.get(
            `/api/v1/reagent/${id}`,
        );
        dispatch({
            type: REAGENT_GET_BY_KEY_SUCCESS,
            payload: data,
        });
        return data.result;
    } catch (error) {
        dispatch({
            type: REAGENT_GET_BY_KEY_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const addReagent = ({ name, description, price }, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: REAGENT_ADD_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.post(
            "/api/v1/reagent",
            { name, description, price },
            config,
        );
        dispatch(getReagents(queryArgs || {}));
        dispatch({
            type: REAGENT_ADD_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: REAGENT_ADD_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const editReagent = ({ id, name, description, price }, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: REAGENT_EDIT_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.put(
            "/api/v1/reagent",
            { id, name, description, price },
            config,
        );
        dispatch(getReagents(queryArgs || {}));
        dispatch({
            type: REAGENT_EDIT_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: REAGENT_EDIT_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const deleteReagent = (id, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: REAGENT_DELETE_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.delete(
            "/api/v1/reagent",
            { data: { id } },
            config,
        );
        dispatch(getReagents(queryArgs || {}));
        dispatch({
            type: REAGENT_DELETE_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: REAGENT_DELETE_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

